import styles from './LegendComponent.module.scss'

export const LegendComponent = () => {
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				Легенда
			</div>
			<ul className={styles.content}>
				<li className="finex">FinEx</li>
				<li className="vtb">ВИМ Инвестиции (ВТБ)</li>
				<li className="rshb">РСХБ</li>
				<li className="open">Открытие/Менеджмент консалтинг</li>
				<li className="sber">Первая (Сбербанк)</li>
				<li className="alpha">Альфа Капитал</li>
				<li className="tinkoff">Тинькофф</li>
				<li className="etc">Прочие (ITI FUNDS, Газпромбанк, Freedom Finance, ...)</li>
			</ul>
		</div>
	);
}